import { Star } from "lucide-react"

export default function NewCardLabel() {
  return (
    <div className="mb-5 flex w-full items-center justify-end">
      <span className="flex select-none items-center justify-center gap-1 rounded-[6px] bg-orange-500 p-1 text-xs font-medium text-white">
        <Star className="!size-4" />
        <span className="uppercase">Tarjeta nueva</span>
      </span>
    </div>
  )
}
